(function () {
    'use strict';

    angular.module('swif.ui')

    .directive('swifBarcode', swifBarcode);

    /**
    * @ngdoc directive
    * @name swif.ui:swifBarcode
    * @module swif.ui
    * @restrict A
    * @description ?
    **/
    function swifBarcode() {
        return {
            restrict: 'A',
            require: '?ngModel',
            scope: {
                swifBarcode: '@',
                options: '=?'
            },
            link: function (scope, element, attr, ngModel) {
                if (!scope.options) {
                    scope.options = {};
                }
                _.defaults(scope.options, {
                    width:  2,
                    height: 100,
                    quite: 10,
                    format: 'CODE128',
                    displayValue: false,
                    font: 'monospace',
                    textAlign: 'center',
                    fontSize: 12,
                    backgroundColor: '',
                    lineColor: '#000'
                });
                if (ngModel) {
                    ngModel.$render = function () {
                        var vv = ngModel.$viewValue;
                        scope.swifBarcode = vv;
                    };
                }
                var updateBarCode = function () {
                    if (scope.swifBarcode) {
                        element.JsBarcode(scope.swifBarcode, scope.options);
                    } else {
                        element.removeAttr('src');
                    }
                };
                scope.$watch('swifBarcode', function (newV) {
                    updateBarCode();
                }, true);
                scope.$watch('options', function (newV) {
                    updateBarCode();
                }, true);
            }
        };
    }

})();